import { render, staticRenderFns } from "./SliderQuestion.vue?vue&type=template&id=56995938"
import script from "./SliderQuestion.vue?vue&type=script&lang=js"
export * from "./SliderQuestion.vue?vue&type=script&lang=js"
import style0 from "./SliderQuestion.vue?vue&type=style&index=0&id=56995938&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports